import Seo from "@/components/Seo";
import { Btn, FORMATIONS } from "@/components/Shared";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="page-404">
      <Seo
        title="Page introuvable — Form Action Pro"
        description="La page demandée n'existe pas ou a été déplacée. Retournez à l'accueil de Form Action Pro, découvrez nos formations ou contactez-nous."
        path="/404"
      />
      <section className="bg-sable py-24 md:py-32">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <Compass className="text-vert-dark mx-auto mb-6" size={40} />
          <p className="font-serif text-[72px] md:text-[96px] text-vert/30 leading-none mb-4">404</p>
          <h1 className="font-serif text-3xl md:text-4xl text-marine mb-4">
            Cette page est introuvable.
          </h1>
          <p className="font-sans text-base text-marine/75 leading-[1.7] mb-10">
            La page que vous cherchez n’existe pas ou a été déplacée. Voici quelques points de
            repère pour poursuivre votre visite.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Btn to="/" testid="404-cta-accueil" variant="primary">
              Retour à l’accueil
            </Btn>
            <Btn to="/contact" testid="404-cta-contact" variant="outlineDark">
              Nous contacter
            </Btn>
          </div>
          <div className="bg-white border border-bordure rounded-lg p-6 text-left">
            <p className="font-sans text-xs font-semibold uppercase tracking-[2px] text-vert-dark mb-3">
              Nos formations
            </p>
            <ul className="space-y-2">
              {FORMATIONS.map((f) => (
                <li key={f.to}>
                  <Link
                    to={f.to}
                    data-testid={`404-lien-${f.to.split("/").pop()}`}
                    className="font-sans text-sm text-marine hover:text-vert-dark transition-colors"
                  >
                    {f.label} — {f.duree}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
